<template>
	<Container v-if="news_by_pk">
		<Title>
			<div>
				<router-link class="text-primary no-underline" to="/noticias"
					>Noticias</router-link
				>
				<img
					class="inline"
					src="@/assets/img/breadcrumb.svg"
					alt="breadcrumb"
				/>
				<span v-if="news_by_pk" class="text-gray-600">{{
					news_by_pk.title
				}}</span>
			</div>
		</Title>
		<Card>
			<div class="flex flex-col md:flex-row">
				<div class="news-body">
					<h1 class="font-medium m-0 text-primary text-lg">
						{{ news_by_pk.title }}
					</h1>
					<span class="italic block my-4">{{ news_by_pk.category }}</span>
					<span>{{ news_by_pk.publishing_date | moment('DD/MM/YYYY') }}</span>
					<div class="italic block my-4" v-html="news_by_pk.description"></div>
					<div v-html="news_by_pk.body"></div>
				</div>
				<div
					v-if="news_by_pk.image"
					class="ml-0 md:ml-8 mt-6 md:mt-0"
					style="flex: 0 0 500px"
				>
					<img :src="news_by_pk.image" />
				</div>
			</div>
		</Card>
	</Container>
</template>

<script>
import gql from 'graphql-tag'

export default {
	apollo: {
		news_by_pk: {
			query: gql`
				query ($news_id: bigint!) {
					news_by_pk(id: $news_id) {
						title
						news_category {
							category_name
						}
						description
						body
						image {
							url
						}
						publishing_date
					}
				}
			`,
			variables() {
				return {
					news_id: this.id
				}
			},
			update(data) {
				const item = data.news_by_pk
				const image =
					item.image && item.image.url
						? `${
								process.env.VUE_APP_API_URL
						  }/public/assets/images/?key=${item.image.url.slice(1)}&width=500`
						: undefined

				return {
					title: item.title,
					category: item.news_category.category_name,
					description: item.description,
					body: item.body,
					image: image,
					publishing_date: item.publishing_date
				}
			}
		}
	},
	props: {
		id: String
	}
}
</script>

<style>
.news-body a {
	text-decoration: underline;
}
</style>
